import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer } from 'react-toastify';
import Helmet from 'react-helmet';
import RingLoader from 'react-spinners/RingLoader';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { AssetSearch, AssetUploader, SideBar, Template } from '../editor';
import CreatePage from '../editor/page/CreatePage';
import logo from '../../images/drapcode-logo-white.svg';
import WelcomePopup from './WelcomePopup';
import DefaultPage from '../tutorial/DefaultPage';
import { checkAndValidateProject, getCookie, updateUserIpInCookie } from './app_util';
import Shortcut from '../../shortcut/Shortcut';

const css = {
  margin: 'auto',
  marginTop: '15%',
  display: 'block',
};

const homeAppStyle = {
  height: '100%',
};

const imageStyle = {
  display: 'block',
  height: 30,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '5px',
  zIndex: 10,
  position: 'relative',
  cursor: 'pointer',
};

const divImageStyle = {
  display: 'block',
  position: 'absolute',
  backgroundColor: '#303453', // darken(@builder-base-color, 10%)
  width: '100%',
  zIndex: 4,
};

const toastrStyle = {
  width: 'auto',
  minWidth: '15vw',
};

export class App extends Component {
  static propTypes = {
    children: PropTypes.node,
    editor: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    showLoader: false,
    showContent: false,
  };

  static defaultProps = {
    children: '',
  };

  componentDidMount = async () => {
    const { location, actions } = this.props;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const version = extractPath[2];
    const projectId = extractPath[4];
    if (!projectId) {
      console.log("** I don't have project details");
      window.location.href = `${process.env.REACT_APP_ORGANIZATION}`;
    }
    this.setState({ showLoader: true });
    if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
      this.setState({ showLoader: false, showContent: true });
      actions.loadProjectDetail({ projectId, version });
      actions.loadProjectVersion({ projectId });
    } else {
      const newState = await checkAndValidateProject(projectId, version, actions);
      if (newState && newState.showContent) {
        actions.loadProjectDetail({ projectId, version });
        actions.loadProjectVersion({ projectId });
        this.setState(newState);
      } else {
        this.setState(newState);
      }
    }

    const userIp = getCookie('userIp');
    if (!userIp) {
      await updateUserIpInCookie();
    }
    const lastAccess = getCookie('lastAccess');
    if (!lastAccess) {
      await actions.addLastAccess({ projectId });
    }
  };

  showBuilder = () => {
    const { location, children } = this.props;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const version = extractPath[2];
    const projectId = extractPath[4];
    let pageId = extractPath[6];
    let snippetId = extractPath[6];
    if (path.startsWith('/plugin/') || path.startsWith('/template/')) {
      pageId = '';
    }
    if (projectId) {
      return (
        <>
          {/**
           * //?INFO: -> Commented code below to disable Builder Loader Screen
           *  <LoaderScreen /> */}
          <Shortcut projectId={projectId} version={version} />
          <SideBar projectId={projectId} pageId={pageId} version={version} />
          {this.state.showContent && (
            <>
              <CreatePage projectId={projectId} pageId={pageId} version={version} />
              <Template projectId={projectId} snippetId={snippetId} version={version} />
              <AssetUploader projectId={projectId} version={version} />
              <AssetSearch projectId={projectId} version={version} />
              <WelcomePopup projectId={projectId} version={version} />
              <DefaultPage />
            </>
          )}
        </>
      );
    }
  };

  render() {
    const { location, children } = this.props;
    const path = location.pathname;
    const { showLoader, showContent } = this.state;
    const { projectDetail } = this.props.home;
    if (showLoader) {
      return <RingLoader cssOverride={css} size="80px" color={'#1d1d1d'} loading={showLoader} />;
    }

    if (path === '/login' || path === '/') {
      return <div className="layout-container">{children}</div>;
    }
    if (!showContent) {
      return (
        <div className="page-container bg-blue-grey-900 pt-2">
          <h1 style={{ textAlign: 'center' }}>You don't have permission to access the project.</h1>
        </div>
      );
    }
    if (projectDetail && projectDetail.isDeleted) {
      return (
        <div className="page-container bg-blue-grey-900 pt-2">
          <h1 style={{ textAlign: 'center' }}>This project has been deleted.</h1>
        </div>
      );
    }
    return (
      <div className="home-app" style={homeAppStyle}>
        <Helmet>
          <title>DrapCode | Build Awesome Web Applications</title>
        </Helmet>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={toastrStyle}
        />
        <div style={divImageStyle}>
          <img
            src={logo}
            style={imageStyle}
            alt="DrapCode Logo"
            title="Goto Dashboard"
            onClick={() => window.open(`${process.env.REACT_APP_ORGANIZATION}dashboard`, '_blank')}
          />
        </div>
        {this.showBuilder()}
        {children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
